// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import "./../../assets/css/TravelSlider.css";

// const sliderData = [
//   {
//     image:
//       "https://images.unsplash.com/photo-1531804055935-76f44d7c3621?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80",
//     title: "Discover Tropical Paradises",
//     description:
//       "Explore breathtaking destinations that will take your breath away.",
//     buttonText: "Explore Now",
//   },
//   {
//     image:
//       "https://images.unsplash.com/photo-1530789253388-582c481c54b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80",
//     title: "Mountain Expeditions",
//     description:
//       "Embark on thrilling journeys through majestic mountain landscapes.",
//     buttonText: "Plan Trip",
//   },
//   {
//     image:
//       "https://images.unsplash.com/photo-1531804055935-76f44d7c3621?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80",
//     title: "Immerse in Local Cultures",
//     description:
//       "Experience the world's most fascinating cultures and traditions.",
//     buttonText: "Discover More",
//   },
// ];

// export default function TravelSlider({homeImages}) {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % sliderData.length);
//     }, 5000);

//     return () => clearInterval(timer);
//   }, []);

//   const handleNextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % sliderData.length);
//   };

//   const handlePrevSlide = () => {
//     setCurrentSlide(
//       (prev) => (prev - 1 + sliderData.length) % sliderData.length
//     );
//   };

//   return (
//     <div className="travel-slider-container">
//       <AnimatePresence mode="wait">
    
//         <motion.div
//           key={currentSlide}
//           className="slider-item"
//           initial={{ opacity: 0, scale: 1.1 }}
//           animate={{ opacity: 1, scale: 1 }}
//           exit={{ opacity: 0, scale: 0.9 }}
//           transition={{ duration: 0.7, ease: "easeInOut" }}
//         >
//           <div
//             className="slider-background"
//             style={{
//               backgroundImage: `url(${sliderData[currentSlide].image})`,
//             }}
//           />
//           <div className="slider-overlay"></div>

//           <div className="slider-content">
//             <motion.h1
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3, duration: 0.6 }}
//               className="slider-title"
//             >
//               {sliderData[currentSlide].title}
//             </motion.h1>

//             <motion.p
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.5, duration: 0.6 }}
//               className="slider-description"
//             >
//               {sliderData[currentSlide].description}
//             </motion.p>

//             <motion.button
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.7, duration: 0.6 }}
//               className="slider-button"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               {sliderData[currentSlide].buttonText}
//             </motion.button>
//           </div>
//         </motion.div>
//       </AnimatePresence>

//       <div className="slider-navigation">
//         <button className="nav-button prev-button" onClick={handlePrevSlide}>
//           &#10094;
//         </button>
//         <div className="slide-indicators">
//           {sliderData.map((_, index) => (
//             <span
//               key={index}
//               className={`indicator ${index === currentSlide ? "active" : ""}`}
//               onClick={() => setCurrentSlide(index)}
//             />
//           ))}
//         </div>
//         <button className="nav-button next-button" onClick={handleNextSlide}>
//           &#10095;
//         </button>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./../../assets/css/TravelSlider.css";
import BASE_URL from "../commanfile";

export default function TravelSlider({ homeImages = [] }) {
  const [currentSlide, setCurrentSlide] = useState(0);
useEffect(() => {
  homeImages.forEach((img) => {
    const primary = `${BASE_URL}${img?.image?.substring(1)}`;
    const fallback = `${BASE_URL}/api/image?file=${encodeURIComponent(
      img?.image?.substring(1) || ""
    )}`;

    const image = new Image();

    image.src = primary;

    image.onerror = () => {
      image.onerror = null; // prevent loop
      image.src = fallback;
    };
  });
}, [homeImages]);
  useEffect(() => {
    if (homeImages.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % homeImages.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [homeImages]);

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % homeImages.length);
  };

  const handlePrevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + homeImages.length) % homeImages.length
    );
  };

  if (!homeImages.length) {
    return <div>Loading...</div>;
  }
console.log("homeImages", `${BASE_URL}${homeImages[currentSlide].image?.substring(1)}`);
  return (
    <div className="travel-slider-container">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          className="slider-item"
      
        >
       <div
  className="slider-background"
  style={{
    backgroundImage:`url(${BASE_URL}/api/image?file=${encodeURIComponent(homeImages[currentSlide].image?.substring(1))})`,
  }}
/>

          <div className="slider-overlay"></div>

          <div className="slider-content">
            <motion.h1
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="slider-title"
            >
              {homeImages[currentSlide].label}
            </motion.h1>

            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="slider-description"
            >
              {homeImages[currentSlide].description}
            </motion.p>

            {/* <motion.button
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.6 }}
              className="slider-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Explore Now
            </motion.button> */}
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="slider-navigation">
        <button className="nav-button prev-button" onClick={handlePrevSlide}>
          &#10094;
        </button>
        <div className="slide-indicators">
          {homeImages.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
        <button className="nav-button next-button" onClick={handleNextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
}
